/* Color-sensitive contents for Defy Custom; other product sections remain independent. */
(() => {
  if (window.defyCustomIncludedLoaded) return;
  window.defyCustomIncludedLoaded = true;
  const bindings = new Map();
  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');

  function initialize() {
    document.querySelectorAll('[data-defy-custom-included-config]').forEach((element) => {
      const root = element.closest('.shopify-section');
      const picker = document.querySelector('defy-custom-variant-radios');
      if (!root || !picker) return;
      bindings.get(root.id)?.abort();
      const controller = new AbortController();
      bindings.set(root.id, controller);
      const config = JSON.parse(element.textContent);

      function setImage(container, src, alt) {
        const image = container?.querySelector('img');
        if (!image || !src) return;
        if (image.getAttribute('src') !== src) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = src;
        }
        image.alt = alt || '';
      }

      function update() {
        const fieldsets = Array.from(picker.querySelectorAll('fieldset[data-option-index]'));
        const selectedOptions = fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
        const colorFieldset = fieldsets.find((fieldset) => fieldset.dataset.customOption === 'color')
          || fieldsets.find((fieldset) => normalize(fieldset.querySelector('input')?.name) === normalize(config.colorOptionName));
        const color = normalize(colorFieldset?.querySelector('input:checked')?.value);
        const componentScheme = ['silver', 'onyx'].includes(color) ? 'silver' : 'black';
        const palmPadScheme = ['silver', 'yinyang'].includes(color) ? 'silver' : 'black';
        const variant = config.variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));
        const grid = root.querySelector('[data-whats-included-color]');
        if (grid) grid.dataset.whatsIncludedColor = componentScheme;

        config.cards.forEach((item) => {
          const card = root.querySelector(`[data-custom-included-card="${CSS.escape(item.id)}"]`);
          if (!card) return;
          const scheme = item.isPalmPads ? palmPadScheme : componentScheme;
          const images = item[scheme];
          const main = card.querySelector('[data-custom-included-image]');
          const hover = card.querySelector('[data-custom-included-hover]');
          if (item.useVariantImage) {
            if (variant?.src) setImage(main, variant.src, variant.alt);
          } else {
            setImage(main, images.src, item.alt);
          }
          if (hover) {
            hover.hidden = !images.hoverSrc;
            setImage(hover, images.hoverSrc, item.alt);
          }
          card.classList.toggle('has-hover-effect', Boolean(images.hoverSrc));
          main?.classList.toggle('card-item--image__initial', Boolean(images.hoverSrc));
        });
      }

      picker.addEventListener('change', update, {signal: controller.signal});
      update();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    const id = event.target.id;
    bindings.get(id)?.abort();
    bindings.delete(id);
  });
})();
